export enum PopupFrameOutgoingEvent {
  CLOSE_POPUP = 'closePopup',
  REQUEST_WINDOW_HEIGHT = 'requestWindowHeight',
  SECTION_RESIZE = 'sectionResize',
  SECTION_ENTER = 'sectionEnter',
  SECTION_LEAVING = 'sectionLeaving',
  SECTION_LEFT = 'sectionLeft',
  POPOVER_SHOW = 'popoverShow',
  POPOVER_HIDE = 'popoverHide',
  SUBMIT = 'submit'
}

export enum PopupFrameIncomingEvent {
  RESPONSE_WINDOW_HEIGHT = 'responseWindowHeight'
}

export interface IncomingIframeEvent {
  type: string;
  name: string;
  data: unknown;
}

export interface SectionFrame {
  id: number;
  position: string;
  w: number;
  h: number;
  x: number;
  y: number;
  widthStyle: string;
  overlay: boolean;
  boxShadowBlur: number;
}

// TODO: Investigate if we can type this differently. Not entirely sure how.
// eslint-disable-next-line
export type ListenerCallback = (data: any) => void;
